import { FC, PropsWithChildren, useState } from 'react';
import { EditorContext } from '.';
import { TinyMCE } from '../../types';
import { useGetNewContentEffect } from '../../hooks/useGetNewContentEffect';
import { useSetNewContentEffect } from '../../hooks/useSetNewContentEffect';

export const EditorContextProvider: FC<PropsWithChildren<NonNullable<unknown>>> = ({
  children,
}) => {
  const [editor, setEditor] = useState<TinyMCE | null>(null);

  useSetNewContentEffect(editor);
  useGetNewContentEffect(editor);

  return (
    <EditorContext.Provider
      value={{
        editor,
        setEditor,
      }}
    >
      {children}
    </EditorContext.Provider>
  );
};
